module.exports = __webpack_public_path__ + "img/redo.2475c95d.svg";